import React, { useEffect, useRef, memo } from 'react';

const EconomicCalendarWidget: React.FC = () => {
  const container = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!container.current) return;

    // Clear previous content to avoid duplicates on re-mounts
    container.current.innerHTML = '';

    const widgetContainer = document.createElement('div');
    widgetContainer.className = 'tradingview-widget-container__widget';
    
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
    script.type = 'text/javascript';
    script.async = true;
    
    // Add error handling
    script.onerror = () => {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to load TradingView Economic Calendar widget');
      }
    };
    
    script.innerHTML = JSON.stringify({
      "colorTheme": "dark",
      "isTransparent": false,
      "width": "100%",
      "height": "500",
      "locale": "en",
      "importanceFilter": "-1,0,1",
      "countryFilter": "us,eu,gb,jp,cn,au,ca,ch,de,fr,it,es"
    });

    widgetContainer.appendChild(script);
    container.current.appendChild(widgetContainer);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      const currentContainer = container.current;
      if (currentContainer) {
        currentContainer.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="tradingview-widget-container" ref={container}>
      <div className="tradingview-widget-copyright" style={{ fontSize: '13px', marginTop: '10px', textAlign: 'center' }}>
        <a href="https://www.tradingview.com/" rel="noopener noreferrer" target="_blank" style={{ color: '#06b6d4', textDecoration: 'none' }}>
          <span>Economic Calendar by TradingView</span>
        </a>
      </div>
    </div>
  );
};

export default memo(EconomicCalendarWidget);

